import React from "react";
import { STEPS, STEP_COLORS } from "@/lib/stages";
import { Check } from "@phosphor-icons/react";

// Render the per-item progress array (from the deployed backend) as a horizontal stepper.
// Item.current_step + item.progress[] inform per-stage completion.
export default function StageProgress({ item }) {
  const progress = item?.progress || [];
  // Build a lookup of step -> completion
  const map = {};
  for (const p of progress) map[p.step] = p;

  const currentStep = item?.current_step || "New";
  const currentIdx = STEPS.indexOf(currentStep);

  return (
    <div className="flex items-center w-full gap-1" data-testid="stage-progress">
      {STEPS.map((s, i) => {
        const info = map[s];
        const completed = info?.completed || (i < currentIdx && s !== "New");
        const active = s === currentStep;
        const c = STEP_COLORS[s];
        const isStartStep = s === "New";
        return (
          <React.Fragment key={s}>
            <div className="flex flex-col items-center flex-1 min-w-0">
              <div
                className={`flex items-center justify-center w-9 h-9 rounded-full border-2 transition-colors`}
                style={{
                  borderColor: completed || active ? c.border : "#D4D4D8",
                  background: completed ? c.bg : "#FFFFFF",
                  color: completed ? c.text : (active ? c.text : "#A1A1AA"),
                  ...(active ? { boxShadow: `0 0 0 4px ${c.border}33` } : {}),
                }}
              >
                {completed && !isStartStep ? (
                  <Check size={16} weight="bold" />
                ) : (
                  <span className="text-xs font-bold">{i + 1}</span>
                )}
              </div>
              <span className={`mt-1.5 text-[10px] uppercase tracking-widest font-semibold truncate ${completed || active ? "text-zinc-900" : "text-zinc-400"}`}>
                {s}
              </span>
              {info && info.count != null && info.total != null && (
                <span className="text-[10px] text-zinc-500 font-mono">{info.count}/{info.total}</span>
              )}
            </div>
            {i < STEPS.length - 1 && (
              <div
                className="h-0.5 flex-1 -mt-8"
                style={{ background: i < currentIdx ? STEP_COLORS[STEPS[i + 1]].border : "#E4E4E7" }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
